// @flow

const stringTrim = (value: string) => value.trim()

export default stringTrim
